import { get } from './baseAxios';
import { API_LANGUAGE } from './urls';
import { LanguageType, ResponseType } from '@types';

const getLanguages = (): Promise<ResponseType<LanguageType[]>> => get(API_LANGUAGE);

export {
    getLanguages
}